module.exports = __webpack_public_path__ + "img/ИФ-1(А)-046.a489d0de.png";